"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MulticamTooltip = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./MulticamTooltip.css");

var _ = require("../..");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Imports
// Multicam Tooltip
var MulticamTooltip = function MulticamTooltip(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      hideAfter = _ref.hideAfter;
  (0, _react.useEffect)(function () {
    var tooltipTimeout = null;

    if (open && hideAfter) {
      tooltipTimeout = setTimeout(function () {
        if (typeof onClose === "function") {
          onClose();
        }
      }, hideAfter);
    }

    return function () {
      tooltipTimeout && clearTimeout(tooltipTimeout);
    };
  }, [open]);

  var handleOnClose = function handleOnClose(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (typeof onClose === "function") {
      onClose();
    }
  };

  var handleOnMouseOver = function handleOnMouseOver(e) {
    if (e) {
      e.stopPropagation();
    }
  };

  if (open) {
    return /*#__PURE__*/_react.default.createElement(_.Element, {
      className: "MulticamTooltip",
      onMouseOver: function onMouseOver(e) {
        return handleOnMouseOver(e);
      },
      onClick: function onClick(e) {
        return handleOnClose(e);
      }
    }, /*#__PURE__*/_react.default.createElement(_.Label, {
      bold: true,
      type: _.Label.Type.Body
    }, "Filmed in MultiCam"), /*#__PURE__*/_react.default.createElement(_.Element, {
      className: "arrow"
    }));
  } else {
    return null;
  }
};

exports.MulticamTooltip = MulticamTooltip;
MulticamTooltip.defaultProps = {
  hideAfter: 3000
};